import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
  name: "loader",
  initialState: { visible: false },
  reducers: {
    showLoader: (state) => {
      state.visible = true;
    },
    hideLoader: (state) => {
      state.visible = false;
    },
    setLoader: (state, action) => {
      state.visible = action.payload;
    },
  },
});

export const actions = loaderSlice.actions;
const selectLoader = (state) => state.loader.visible;

export const selectors = {
  selectLoader,
};

export const loaderReducer = loaderSlice.reducer;
